"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Button_1 = __importDefault(require("../Button"));
var Divider_1 = __importDefault(require("../Divider"));
var ApplyButton = function (_a) {
    var handlerApply = _a.handlerApply, formatMessage = _a.formatMessage, _b = _a.applyButtonProps, applyButtonProps = _b === void 0 ? {} : _b;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Divider_1.default, { light: true }),
        react_1.default.createElement(Button_1.default, __assign({ onClick: handlerApply, size: "large", color: "primary", variant: "text", fullWidth: true }, applyButtonProps), formatMessage({ id: 'apply', defaultMessage: 'Apply' }))));
};
exports.default = ApplyButton;
